import React from "react";

const YouTubeEmbed = ({ videoId }) => {
  return (
    <div className="yt-wrapper">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>

      <style jsx>{`
        .yt-wrapper {
          position: relative;
          width: 100%;
          max-width: 100%;
          padding-bottom: 56.25%; /* 16:9 responsive ratio */
          height: 0;
          overflow: hidden;
          border-radius: 14px;
        }

        .yt-wrapper iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        /* Mobile Styling */
        @media (max-width: 600px) {
          .yt-wrapper {
            padding-bottom: 58% !important;
            border-radius: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default YouTubeEmbed;
